import Instagram from "../../assets/instagram.svg";
import Facebook from "../../assets/facebook.svg";
const Social = () => {
  return (
    <div className="Social-media">
      <a href="https://www.instagram.com/versusraceteam/?hl=en">
        <img className="icon instagram_icon" src={Instagram} alt="instagram" />
      </a>
      <a href="https://www.facebook.com/p/Versus-Racing-61550970605046/">
        <img className="icon facebook_icon" src={Facebook} alt="Facebook" />
      </a>
    </div>
  );
};

export default Social;
